import { Link } from "react-router-dom";
import { h5LegalUrl } from "./legalLinks";

type Props = {
  linkClassName?: string;
};

/** 登录页协议文案（H5 站内路由打开） */
export function LoginLegalAgreeText(props: Props) {
  const linkClass = props.linkClassName ?? "login-page-agree-link";
  return (
    <span>
      我已阅读并同意
      <Link className={linkClass} to={h5LegalUrl("user-agreement")} onClick={(e) => e.stopPropagation()}>
        《用户协议》
      </Link>
      与
      <Link className={linkClass} to={h5LegalUrl("privacy")} onClick={(e) => e.stopPropagation()}>
        《隐私政策》
      </Link>
    </span>
  );
}
